import {
  EDUTAINMENT_FORM_LINK_REPLACEMENT,
  LEGAL_TAB_SLUG_REPLACEMENT,
  PRODUCT_CATEGORY_REPLACEMENT,
  PROFILE_TAB_SLUG_REPLACEMENT,
  TOKEN_REPLACEMENT,
  UID_REPLACEMENT,
} from '@lib/core/service/consts';

export const PAGES = {
  error: { badRequest: '/error/', forbidden: '/access_denied/', notFound: '/not_found/' },
  ta: {
    // ! Rename to fa/pmi after 0.9 release
    dutyFree: '/duty-free/',
    landing: '/guided_trial/',
    landingRemote: '/remotegt/',
    linkGenerator: '/link-generator/',
    openIntegration: '/open-integration/',
    products: {
      bestMatch: '/products/best_match/',
      bundles: '/products/bundles/',
    },
    quiz: {
      crafted: '/quiz/crafted/',
      ecommerce: '/quiz/taste-ecommerce/',
      local: '/quiz/taste-local/',
      remote: '/quiz/taste-remote/',
      shortRecommender: '/quiz/taste-short-recommender/',
    },
    result: '/result/',
    shortRecommender: '/short-recommender/',
  },
  vinhood: {
    about: '/about/',
    action: '/action/',
    ageAndGender: '/age-and-gender/',
    aiRecommendation: '/ai-recommendation/',
    catalog: '/catalog/',
    characterDetails: '/character-details/',
    eanError: '/ean_error/',
    edutainment: '/edutainment/',
    edutainmentForm: `/edutainment-form/${PRODUCT_CATEGORY_REPLACEMENT}/${EDUTAINMENT_FORM_LINK_REPLACEMENT}`,
    experiences: '/experiences/',
    explore: '/explore/',
    exploreList: '/explore-list/',
    feedback: '/feedback/',
    globalSearchResults: '/search-results/',
    hint: '/hint/',
    home: '/home/',
    kioskForceLogout: '/kiosk-force-logout/',
    kioskLogin: '/login/',
    // ? nested routewelcome: '/welcome/',
    leaderboard: '/leaderboard/',
    legal: {
      cookies: '/cookie-policy/',
      generalServiceTerms: `/general-service-terms/`,
      privacy: '/privacy-policy/',
      tabs: `/legal/tab/${LEGAL_TAB_SLUG_REPLACEMENT}/`,
      termsConditions: '/terms-and-conditions/',
    },

    product: `/product/`,

    profile: `/profile/${PROFILE_TAB_SLUG_REPLACEMENT}/`,

    quiz: {
      chooseExpert: '/quiz/choose/expert/',
      chooseTaste: '/quiz/choose/taste/',
      expert: '/quiz/expert/',
      multiProduct: '/quiz/multi-product/',
      recipe: '/quiz/recipe/',
      situational: '/quiz/situational/',
      taste: '/quiz/taste/',
    },

    quizResults: {
      result: '/result/',
      situational: '/situational_result/',
    },

    recipeSearch: '/recipe-search/',

    redirect: '/redirect/',

    registration: '/email-registration/',
    resetPassword: '/reset/',
    searchCatalog: '/search-catalog/',

    setPassword: `/reset-password/${UID_REPLACEMENT}/${TOKEN_REPLACEMENT}/`,

    signIn: '/sign-in/',

    start: '/',

    suggestion: '/suggestion/',
    surveyGame: '/survey-game/',
    tasteId: {
      tasteId: '/taste-id/',
      tasteIdLegal: '/taste-id/legal/',
      tasteIdPlacesJournal: '/taste-id/places-journal/',
      tasteIdProductsJournal: '/taste-id/products-journal/',
      tasteIdSettings: '/taste-id/settings/',
      tasteIdTags: '/taste-id/tags/',
    },
    tastePathStartPart: '/taste-path-start/',
    thirdParty: '/third-party/',
    welcome: '/welcome/',
    welcomePrivacy: '/welcome-privacy/',
    widgetLauncher: '/widget-launcher/',
  },
};
